import "./index.scss";

// Numero in evidenza: etichetta, valore, nota. tone: good | warning | critical
export default function Kpi({label, value, note, tone}) {
	return (
		<div className={"kpi" + (tone ? " kpi--" + tone : "")}>
			<div className="kpi__label">{label}</div>
			<div className="kpi__value">{value ?? "—"}</div>
			{note && <div className="kpi__note">{note}</div>}
		</div>
	);
}

export function KpiRow({children}) {
	return <div className="kpi-row">{children}</div>;
}
